// InvoiceVersionsPanel — thin wrapper over the shared VersioningPanel.
//
// Invoice-domain config only. All UX (timeline, diff, modal, aggregate
// banner) is provided by `components/versioning/*`.
import React from 'react';
import VersioningPanel from './versioning/VersioningPanel';

const INVOICE_CONFIG = {
  endpointBase: '/invoices',
  idField: 'id',
  numberKey: 'invoice_number',
  entityLabel: 'الفاتورة',
  actionAmend: 'invoice.amend',
  actionAmendPost: 'invoice.amend.post',
  testIdPrefix: 'inv',
  accentClass: 'bg-blue-600 hover:bg-blue-700',
  amendableFields: [
    { key: 'notes',    label: 'ملاحظات', type: 'textarea' },
    { key: 'total',    label: 'الإجمالي',    type: 'number' },
    { key: 'subtotal', label: 'المبلغ قبل الضريبة', type: 'number' },
    { key: 'tax',      label: 'الضريبة',      type: 'number' },
    { key: 'discount', label: 'الخصم',        type: 'number' },
  ],
  financialFields: new Set([
    'total', 'subtotal', 'tax', 'discount',
    'amount', 'amount_paid', 'amount_remaining',
  ]),
  headlineFieldOrder: ['total', 'subtotal', 'amount', 'tax'],
};

export default function InvoiceVersionsPanel({ invoice, onUpdated }) {
  return (
    <VersioningPanel
      entity={invoice}
      config={INVOICE_CONFIG}
      onUpdated={(data) => onUpdated && onUpdated(data?.invoice || data)}
    />
  );
}
